module.exports = __webpack_public_path__ + "static/img/mastercard.5e04be4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/wallets/mastercard.jpg
// module id = 26
// module chunks = 1